<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Lightbulb Off" class="d-icon d-icon--lightbulb-off" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M.647.647a.5.5 0 0 1 .707 0l10 10a.5.5 0 1 1-.707.707L3.51 4.217c.032.349.163.746.587 1.173.435.401.733.931.849 1.513a.5.5 0 0 1-.981.195 1.805 1.805 0 0 0-.568-.994C2.647 5.354 2.5 4.6 2.5 4c0-.195.017-.39.05-.583a.501.501 0 0 1 .037-.123l-1.94-1.94a.5.5 0 0 1 0-.707ZM6 1.5a2.5 2.5 0 0 0-1.25.335.5.5 0 0 1-.5-.866A3.5 3.5 0 0 1 9.5 3.996c.01.66-.21 1.304-.626 1.818a.5.5 0 1 1-.778-.628A1.82 1.82 0 0 0 8.5 4.009V4A2.5 2.5 0 0 0 6 1.5ZM4 9a.5.5 0 0 1 .5-.5h3a.5.5 0 1 1 0 1h-3A.5.5 0 0 1 4 9Zm1 2.5a.5.5 0 0 1 0-1h2a.5.5 0 1 1 0 1H5Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLightbulbOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
